import { useNavigate } from 'react-router-dom';
import styles from './PaymentProcessingModal.module.scss';
import { isMobile } from 'react-device-detect';
import { useEffect } from 'react';

interface IPropsType {
  closer: React.Dispatch<React.SetStateAction<boolean>>;
}

function PaymentProcessingModal(props: IPropsType) {
  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <div className={`${styles.container} ${isMobile ? styles.isMobile : ''}`}>
      <div className={styles.contentWrap}>
        <div className={styles.textWrap}>
          <span>Verifying Payment Information</span>
          <br />
          <span>Once the payment is completed, we will send you a notification and you can check your order history in My Page.</span>
        </div>
        <div
          className={styles.btnWrap}
          onClick={() => {
            props.closer(false);
            navigate('/');
          }}
        >
          <div className={styles.homeBtn}>Home</div>
        </div>
      </div>
    </div>
  );
}

export default PaymentProcessingModal;